// extracted by mini-css-extract-plugin
export default {"container":"ZggHrDRA","loader":"lSLFZ0zV"};